<template>
  <iButton
    :size="getOptionValue(ButtonSize)"
    :variant="getOptionValue(ButtonType)"
    :width="getOptionValue(LayoutWidth)"
    :height="getOptionValue(LayoutHeight)"
    :icon-left="displayLeftIcon ? getOptionValue(Icon) : ''"
    :icon-right="displayRightIcon ? getOptionValue(Icon) : ''"
    :icon-top="displayTopIcon ? getOptionValue(Icon) : ''"
    :icon-bottom="displayBottomIcon ? getOptionValue(Icon) : ''"
    :style-overrides="buttonStyleOverrides"
    :is-loading="localIsLoading"
    loading-spinner-position="inside"
    @click="handleFollowToggle"
  >
    {{ followButtonText }}
  </iButton>
</template>

<script>
// `~/stores/following-store`, `~/smart-feed/stores/entity/following-entity-store`
// and `~/constants/following-constants` all live outside the editor
// directory tree. Canvas preview keeps the follow state local.
import { ButtonElementMixin } from "%/dynamic-component-editor/standard-elements/button-element/button-element-mixin";
import PositioningOptions from "%/dynamic-component-editor/bundles/positioning-options";
import LayoutWidthHeightOptions from "%/dynamic-component-editor/bundles/layout-width-height-options";
import AppearanceOptions from "%/dynamic-component-editor/bundles/appearance-options";
import ButtonOptions from "%/dynamic-component-editor/bundles/button-options";
import SpacingOptions from "%/dynamic-component-editor/bundles/spacing-options";
import BasicTextOptions from "%/dynamic-component-editor/bundles/basic-text-options";
import TextOptions from "%/dynamic-component-editor/bundles/text-options";
import { UserProfileElementMixin } from "%/dynamic-component-editor/standard-elements/user-profile/user-profile-element-mixin";

export default {
  name: "FollowButton",
  mixins: [UserProfileElementMixin, ButtonElementMixin],
  optionBundles: [
    PositioningOptions,
    new LayoutWidthHeightOptions({
      "default.layout-width": "hug",
      "default.layout-height": "hug",
    }),
    new AppearanceOptions({
      "default.border-radius": "large",
    }, {
      "border-radius": false,
    }),
    new ButtonOptions({}, {
      "button-action": true,
      "link-type": true,
      "href-option": true,
    }),
    SpacingOptions,
    new BasicTextOptions({
      "default.font-color": {
        value: "light",
        source: "theme.font",
      },
    }),
    new TextOptions({
      "default.text-wrap": "wrap",
    }),
  ],
  elementPanelSettings: {
    displayName: "Follow Button",
    displayIcon: "arrow-up",
    elementGroup: "userProfile",
    elementType: "element",
  },
  data() {
    return {
      localIsLoading: false,
      localIsFollowing: false,
    };
  },
  computed: {
    followButtonText() {
      return this.localIsFollowing ? "Following" : "Follow";
    },
  },
  methods: {
    handleFollowToggle() {
      this.localIsFollowing = !this.localIsFollowing;
    },
  },
};
</script>
